<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense color="primary" dark>
        <v-toolbar-title>Quotation</v-toolbar-title>

        <v-spacer />

        <!-- PRINT BUTTON -->
        <v-btn elevation="0" color="success" class="mr-2" @click="printPdf" :disabled="!quotation?.id">
          <v-icon left>mdi-printer</v-icon>
          Print
        </v-btn>

        <!-- STATUS CHIP -->
        <v-chip :color="quotation?.is_locked ? 'red' : 'green'" small dark>
          {{ quotation?.is_locked ? 'Locked' : 'Open' }}
        </v-chip>
      </v-toolbar>

      <v-card-text v-if="quotation">

        <!-- BASIC INFO -->
        <v-row dense>
          <v-col cols="12" md="6">
            <strong>Subject:</strong>
            <div>{{ quotation?.subject }}</div>
          </v-col>

          <v-col cols="12" md="6">
            <strong>Date:</strong>
            <div>{{ formatDateUS(new Date(quotation?.actual_date)) }}</div>
          </v-col>

          <v-col cols="12" md="6">
            <strong>Customer:</strong>
            <div>
              ({{ quotation?.customer?.id }}) {{ quotation?.customer?.name }}
            </div>
          </v-col>

          <v-col cols="12" md="6">
            <strong>Project Code:</strong>
            <div>
              {{ quotation?.project_code?.code || '-' }}
              <small v-if="quotation?.project_code?.description">
                - {{ quotation?.project_code.description }}
              </small>
            </div>
          </v-col>

          <v-col cols="12" md="6">
            <strong>VAT Type:</strong>
            <div>{{ quotation?.vat_type }}</div>
          </v-col>

          <v-col cols="12" md="6">
            <strong>Discount Rate:</strong>
            <div>{{ quotation?.discount_rate }}</div>
          </v-col>

          <v-col cols="12">
            <strong>Notes:</strong>
            <div>{{ quotation?.notes || '-' }}</div>
          </v-col>
        </v-row>

        <v-divider class="my-4" />

        <!-- ITEMS -->
        <h3>Items</h3>

        <v-data-table :headers="headers" :items="quotation?.items" dense disable-pagination hide-default-footer>
          <template v-slot:item.unit_price="{ value }">
            {{ currencyFormat(value) }}
          </template>

          <template v-slot:item.amount="{ item }">
            {{ currencyFormat(item.amount) }}
          </template>

          <template v-slot:item.specs="{ item }">
            <small>{{ item.specs?.join(', ') }}</small>
          </template>

          <template #item.is_service="{ value }">
            <v-icon small :color="value ? 'green' : 'red'">
              {{ value ? 'mdi-check' : 'mdi-close' }}
            </v-icon>
          </template>
          <template #body.append>
            <tr>
              <th colspan="5" class="text-right">Sub Total</th>
              <td class="text-right">
                {{ currencyFormat(quotation?.items_sub_total) }}
              </td>
            </tr>

            <tr>
              <th colspan="5" class="text-right">Discount</th>
              <td class="text-right">
                {{ currencyFormat(quotation?.items_discount) }}
              </td>
            </tr>
            <tr>
              <th colspan="5" class="text-right">Total (vat ex)</th>
              <td class="text-right">
                {{ currencyFormat(quotation?.items_total_vat_ex) }}
              </td>
            </tr>

            <tr>
              <th colspan="5" class="text-right">VAT</th>
              <td class="text-right">
                {{ currencyFormat(quotation?.items_vat_amount) }}
              </td>
            </tr>

            <tr>
              <th colspan="5" class="text-right">
                Total
              </th>
              <th class="text-right">
                <strong class="text-h6">
                  {{ currencyFormat(quotation?.items_total_amount) }}
                </strong>
              </th>
            </tr>
          </template>
        </v-data-table>

        <v-divider class="my-4" />

        <!-- TERMS & CONDITIONS -->
        <h3>Terms & Conditions</h3>

        <v-list dense>
          <v-list-item v-for="(value, key) in quotation?.terms_and_conditions" :key="key">
            <v-list-item-content>
              <strong>{{ key }}</strong>
              <div>{{ value }}</div>
            </v-list-item-content>
          </v-list-item>
        </v-list>

      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
// @ts-nocheck
import appAxios from '@/libs/app-axios'
import { currencyFormat, formatDateUS } from '@/libs/utils'

export default {
  data() {
    return {
      quotation: null,
      headers: [
        { text: 'Description', value: 'description' },
        { text: 'Specs', value: 'specs' },
        { text: 'Unit Price', value: 'unit_price', align: 'right' },
        { text: 'Qty', value: 'quantity', align: 'center' },
        { text: 'Service', value: 'is_service', align: 'center' },
        { text: 'Amount', value: 'amount', align: 'right' },
      ],
    }
  },

  computed: {
    id() {
      return this.$route.params.quotationId
    },
  },

  mounted() {
    this.fetch()
  },

  methods: {
    async fetch() {
      const res = await appAxios().get(`/v3/quotations/${this.id}`)
      this.quotation = res.data.data
    },

    async printPdf() {
      try {
        LoadingPopup.fire('Loading', 'Generating PDF...')
        const { data } = await appAxios().get(`/v3/quotations/${this.id}/pdf`, {
          responseType: 'blob',
        })
        const blob = new Blob([data], { type: 'application/pdf' })
        loadPdf(blob)
        LoadingPopup.close()
      } catch (e) {
        if (isAxiosError(e)) {
          ErrorPopup.fire('Error', e.response?.data?.message || 'Failed to load PDF')
          return
        }
        if (e instanceof Error) {
          ErrorPopup.fire('Error', e.message)
        }
      }
    },
    currencyFormat,
    formatDateUS,
  },
}
</script>